import type { MyTxtPermission } from './permissions.types';
import type { MyTxtSessionUserType } from './myTxtUserTypes';

/**
 * Default permissions for every student-portal route.
 * Portal account types share this baseline so any authenticated student can
 * navigate the portal without needing explicit permissions from the API.
 *
 * To restrict a route to a specific type group later:
 *   1. Remove that permission from the types that shouldn't have it.
 *   2. Change the rule's allowedUserTypes in routeAccess.config.ts.
 */
const BASE_STUDENT_PERMISSIONS: MyTxtPermission[] = [
  'home:read',
  'profile:read',
  'signed-forms:read',
  'txt-training:read',
  'office-check-in:read',
  'scla-application:read',
  'scla-team-roster:read',
  'txt-labs-apprenticeship:read',
  'seals:read',
];

// eslint-disable-next-line import/prefer-default-export
export const ROLE_PERMISSIONS: Record<MyTxtSessionUserType, MyTxtPermission[]> =
  {
    txter: [...BASE_STUDENT_PERMISSIONS],
    alumni: BASE_STUDENT_PERMISSIONS.filter(
      permission => permission !== 'scla-application:read',
    ),
    user: [...BASE_STUDENT_PERMISSIONS],
    other: [...BASE_STUDENT_PERMISSIONS],
    'scla-applicant': [...BASE_STUDENT_PERMISSIONS],
    lil: [...BASE_STUDENT_PERMISSIONS],
  };
